// extracted by mini-css-extract-plugin
module.exports = {"title":"AppearTextCardContentItem_title__51wTx","listItems":"AppearTextCardContentItem_listItems__1T7Mf","textBlockWrapper":"AppearTextCardContentItem_textBlockWrapper__fPg_F"};